import { Pipe, PipeTransform } from '@angular/core';
import { LANG } from 'src/app/models/enums/lang.enum';

@Pipe({
  name: 'hospitalObject',
})
export class HospitalObjectPipe implements PipeTransform {
  transform(
    value: any,
    lang: LANG | string = LANG.KM,
    kh: string = 'name_kh',
    en: string = 'name_en',
  ): string | null {
    if (!value) return null;

    const code = value.code || '';
    const levelCode = value.hospital_package_level?.code || '';

    // Hospital name based on language
    let name = '';
    if (lang === LANG.KM && value[kh]) {
      name = value[kh];
    } else if (lang === LANG.EN && value[en]) {
      name = value[en];
    } else {
      name = value[en] || value[kh] || '';
    }

    // Build full display string only with existing codes
    let fullTitle = '';
    if (code && levelCode) {
      fullTitle = `(${code} - ${levelCode}) `;
    } else if (code) {
      fullTitle = `(${code}) `;
    } else if (levelCode) {
      fullTitle = `(${levelCode}) `;
    }

    return fullTitle + name;
  }
}
